import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const QualityCircle = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox={props.viewBox ? props.viewBox : "0 0 90 90"}
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={props.size}
            height={props.size}>
            <rect x="0.25" width="88" height="88" rx="44" fill={props.color ? props.color : "white"}/>
        </SvgStyled>
    );
};

export default QualityCircle;
